import { DealerID } from "./Dealer";

export type HoldingID = number;

export interface Holding {
  created_on: string;
  updated_on: string;
  id: HoldingID; // Holding Identifier
  name: string; // Holding Name
  dealer_ids: DealerID[]; // List of Dealer Identifiers associated with this Holding
}
